import { render, staticRenderFns } from "./RecoverBannedChip.vue?vue&type=template&id=5787a5cb"
import script from "./RecoverBannedChip.vue?vue&type=script&lang=js"
export * from "./RecoverBannedChip.vue?vue&type=script&lang=js"
import style0 from "./RecoverBannedChip.vue?vue&type=style&index=0&id=5787a5cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports